import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import callToAction from './callToAction.js';
var schema = defineObject('callToActionsBlock', {
    alignment: {
        type: 'string',
        title: 'Alignment',
        description: 'Left by default',
        options: {
            list: [
                'left',
                'center',
                'right'
            ]
        }
    },
    actions: {
        type: 'array',
        title: 'Actions',
        of: [
            {
                type: 'callToAction'
            }
        ]
    }
}, [
    callToAction.schema.callToAction
]);
var validator = z.object({
    _type: z.literal('callToActionsBlock'),
    alignment: z.enum([
        'left',
        'center',
        'right'
    ]).optional(),
    actions: z.array(callToAction.validator).optional()
});
schema.callToActionsBlock;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=callToActionsBlock.js.map